import { apiService } from "../apiService";
import { parsedToken } from "../storageHelper";
import urlConfig from "../../../config/domain";

let pToken: any = parsedToken(),
	userID = pToken ? pToken.username : null;

export const AGetEquityUsableHoldings = (callback: CallableFunction) => {
	if (pToken && pToken.accType !== "CO") {
		apiService(
			{
				url: urlConfig.holding.equityUsable + userID,
				method: "GET",
				authType: "authtoken"
			},
			callback
		);
	}
};

export const AGetEquityUnusableHoldings = (callback: CallableFunction) => {
	if (pToken && pToken.accType !== "CO") {
		apiService(
			{
				url: urlConfig.holding.equityUnusable + userID,
				method: "GET",
				authType: "authtoken"
			},
			callback
		);
	}
};

export const AGetEquitySmallcaseHoldings = (callback: CallableFunction) => {
	if (pToken && pToken.accType !== "CO") {
		apiService(
			{
				url: urlConfig.holding.equitySmallcase,
				method: "GET",
				authType: "bearer"
			},
			callback
		);
	}
};

export const AGetMfHoldings = (callback: CallableFunction) => {
	if (pToken && pToken.accType !== "CO") {
		apiService(
			{
				url: urlConfig.holding.mf + userID,
				method: "GET",
				authType: "authtoken"
			},
			callback
		);
	}
};
